import React from 'react';
import { Grid, ListItem, Paper, Tooltip, Typography, makeStyles } from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { AiFillDelete } from 'react-icons/ai';
import theme from '../../../../app/config/themaConfig';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  box: {
    display: 'flex',
  },
  spreadBox: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 320,
  },
  tableAction: {
    paddingLeft: 0,
    paddingRight: 0,
    margin: '0 auto',
    textAlign: 'center',
    alignItems: 'center',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '600px',
    margin: 'auto',
  },
  actionsStyles: {
    marginLeft: '7%',
  },
  card: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    height: '80px',
    marginTop: '-3%',
    marginBottom: '3.2%',
  },
}));

export const ListEvbiAsig = ({
  handledOpenModalDelete,
  rows,
  isLoanding,
  Asignadas,

}) => {
  const r = rows !== undefined && rows !== null ? rows : [];
  const data = Asignadas;
  const history = useHistory();
  const clases = useStyles();
  const primaryColor = theme.palette.primary.main;

  const validateRowsTable = (item) => {
    if (item !== undefined && item !== null) {
      return item;
    } else {
      return '---';
    }
  };

  return (
    <>
      {isLoanding ? (
        <>Cargando...</>
      ) : (
        data.map((row) => (
          <Paper key={row.id} className={clases.card}>
            <Grid container spacing={1}>
              <Grid item style={{ width: '20.5%' }}>
                {validateRowsTable(row.name)}
              </Grid>
              <Grid item style={{ width: '20%' }}>
                {validateRowsTable(row.ubicacion.value)}
              </Grid>
              <Grid item xs={2} style={{ width: '27%' }}>
                {validateRowsTable(row.estado !== false ? 'Activo' : 'Inactivo')}
              </Grid>
              <Grid item xs={1} style={{ width: '10%', marginLeft: '7%' }} className={clases.actionsStyles}>
                <ListItem button>
                  <Tooltip title="Ver información" aria-label="top-end">
                    <AddCircleOutlineIcon
                      style={{ marginLeft: '35%' }}
                      className={clases.tableAction}
                      color="primary"
                      onClick={() => {
                        history.push({
                          pathname: `/basculas/mediciones/${row.id}`,
                          state: {
                            nameBascula: row.name,
                          },
                        });
                      }}
                    />
                  </Tooltip>
                </ListItem>
              </Grid>

              <Grid item xs={1} style={{ width: '10%' }} className={clases.actionsStyles}>
                <ListItem button>
                  <Tooltip title="Ver información" aria-label="top-end">
                    <AiFillDelete
                      style={{ marginLeft: '30%', fontSize: '25px', color: primaryColor }}
                      className={clases.tableAction}
                      color="primary"
                      onClick={() => {
                        handledOpenModalDelete(row);
                      }}
                    />
                  </Tooltip>
                </ListItem>
              </Grid>
            </Grid>
          </Paper>
        ))
      )}
      {!data || data.length === 0 && (
        <Paper className={clases.card}>
          <Typography variant="h6">No hay Estaciones asignadas a este cliente</Typography>
        </Paper>
      )}
    </>
  );
};


